import { Suspense } from 'react';
import { Redirect, Switch } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import { UnauthSuspense } from './features/auth/UnauthSuspense';
import { Layout } from './features/furniture/layout/Layout';
import { SessionTimeout } from './features/misc/SessionTimeout/SessionTimeout';
import { useCognitoLogin } from './hooks/useCognitoLogin';
import { useDataDogSessionReplay } from './hooks/useDataDogSessionReplay';
import { useLocationChange } from './hooks/useLocationChange';
import { usePrefetchData } from './hooks/usePrefetchData';
import { useSetupAnalytics } from './hooks/useSetupAnalytics';
import { useUserChange } from './hooks/useUserChange';
import { PrivateRoute, privateRoutes, PublicRoute, publicRoutes } from './routes';

function App() {
    useCognitoLogin();
    useSetupAnalytics();
    useLocationChange();
    useUserChange();
    usePrefetchData();
    useDataDogSessionReplay();

    return (
        <Layout>
            <SessionTimeout />
            <ToastContainer
                position="top-right"
                autoClose={5000}
                style={{ zIndex: 1999, width: '500px' }}
                icon={false}
            />
            <Suspense fallback={<UnauthSuspense />}>
                <Switch>
                    {publicRoutes.map(({ path, Component, ...rest }, i) => (
                        <PublicRoute key={i} path={path} Component={Component} {...rest} />
                    ))}
                    {privateRoutes.map(({ path, Component, ...rest }, i) => (
                        <PrivateRoute key={i} path={path} Component={Component} {...rest} />
                    ))}
                    <Redirect from="/" to="/dashboard" />
                </Switch>
            </Suspense>
        </Layout>
    );
}

export default App;
